import { differenceInDays, format } from "date-fns";
import { isNaN } from "lodash-es";

export const formatDisplayDate = (date, omitYear = false) => {
  const formatTemplate = omitYear ? "MMM d" : "MMM d, yyyy";
  const dateObj = new Date(date);
  try {
    return format(dateObj, formatTemplate);
  } catch (e) {
    console.error(`Error formatting date ${date} with template ${formatTemplate}`);
    return '';
  }
};

/**
 *
 * @param {time string in the format hh:mm:ss} time
 * @returns
 */
export const formatDisplayTime = (time) => {
  const dateObj = new Date(time);
  try {
    return format(dateObj, 'HH:mm aa')
  } catch (e) {
    console.error(`Error formatting time ${time}`);
    return '';
  }
};

export const minutesToHoursText = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const minutesRemainder = minutes % 60;
  if (minutesRemainder > 0) {
    return `${hours}h ${minutesRemainder}m`;
  }
  return `${hours}h`;
}

export const isValidDate = (d) => d instanceof Date && !isNaN(d.getTime());

export const getDatePattern = (country) => {
  try {
    const locale = country.toLowerCase();
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };

    // formatToParts() returns array of object breaking down the locales dateformat
    // [
    //  {type: "month", value: "03"},
    //  {type: "literal", value: "/"},
    //  {type: "day", value: "30"},
    //  {type: "literal", value: "/"},
    //  {type: "year", value: "2021"},
    // ]
    const formatter = new Intl.DateTimeFormat(locale, options).formatToParts();

    return formatter.map((e) => {
      switch (e.type) {
        case 'month':
          return 'MM';
        case 'day':
          return 'dd';
        case 'year':
          return 'yyyy';
        default:
          return '';
      };
    }).filter(e => e.length > 0);
  } catch (e) {
    return ['MM', 'dd', 'yyyy'];
  }
}

export const getEndsInText = (endDate) => {
  const now = new Date();
  const end = new Date(endDate);
  const endsInDays = differenceInDays(end, now);
  let endsInDaysText = '';
  if (endsInDays < 0) {
    endsInDaysText = 'Ended';
  } else if (endsInDays === 0) {
    endsInDaysText = 'Ending today';
  } else if (endsInDays === 1) {
    endsInDaysText = 'Ending tomorrow';
  } else if (endsInDays < 7) {
    endsInDaysText = `Ends in ${endsInDays} days`;
  } else {
    endsInDaysText = `Ends on ${format(end, 'MMM dd')}`;
  }
  return endsInDaysText;
};

